export const GET_PERFORMANCE_METRICS_REQUEST =
  'GET_PERFORMANCEM_METRICS_REQUEST';
export const GET_PERFORMANCE_METRICS_SUCCESS =
  'GET_PERFORMANCE_METRICS_SUCCESS';
export const GET_PERFORMANCE_METRICS_FAILURE =
  'GET_PERFORMANCE_METRICS_FAILURE';
export const PERFORMANCE_METRICS_RESET = 'PERFORMANCE_METRICS_RESET';
